import { httpClient } from "../../configs/http-client";

export type UserSettings = {
  similarity: number;
};

export type UserProfile = {
  id: string;
  email: string;
  settings: UserSettings;
};

export const getMe = async () => {
  const { data } = await httpClient<UserProfile>("/users/me");

  return data;
};

export const updateUserSettings = async (payload: Partial<UserSettings>) => {
  const { data } = await httpClient.put("/users/settings", {
    similarity: payload.similarity,
  });

  return data;
};
